<template>
  <v-form
    ref="bt-form-freespins"
    v-model="bonus.valid"
  >
    <v-text-field
      label="Freespins Name"
      v-model="bonus.name"
      dense
    />

    <v-row justify="center" class="px-0 mx-0">
      <v-select
        label="Rollover Type"
        :rules="[v => !!v || 'Rollover Type is required']"
        v-model="bonus.rollover_type"
        :items="rollover_type"
        dense
      />

      <v-checkbox
        label="Sticky bonus"
        v-model="bonus.sticky"
        hide-details
        class="ml-3 mt-0 pt-2"
        dense
      />
    </v-row>

    <v-row justify="center" class="px-0 mx-0">
      <v-combobox
        label="Brands (filter)"
        auto-select-first
        :search-input.sync="brandsFilterInput"
        @input="clearBrandFilter"
        v-model="brandsFilter"
        :items="brands"
        class="col-5 pl-0"
        dense
      />
      <v-autocomplete
        class="col-7 pr-0"
        label="Game"
        item-text="name"
        item-value="game_id"
        clearable
        v-model="bonus.game_id"
        :loading="loadingGames"
        :items="filteredGames"
        dense
      >
        <template slot="selection" slot-scope="{ item }">
          <div class="d-flex">
            <span v-html="item.name" />
            &nbsp;
            <small>({{ item.system_name }})</small>
          </div>
        </template>
        <template slot="item" slot-scope="{ item }">
          <div style="width: 100%">
            <span v-html="item.name"></span>
            <small class="float-right">({{ item.system_name }})</small>
          </div>
        </template>

      </v-autocomplete>
    </v-row>

    <v-row justify="center">
      <v-text-field
        required
        label="Wager"
        type="number"
        class="col-2 bonus-template_lh-28"
        :rules="[v => !!toString(v) || 'Wager is required']"
        v-model="bonus.wager"
        hide-details
        dense
      />

      <v-select
        label="Status"
        :rules="[v => !!v || 'Status is required']"
        v-model="bonus.status"
        :items="statuses"
        hide-details
        class="col-3"
        dense
      />


      <v-text-field
        required
        label="Expire days"
        type="number"
        class="col-3 pb-1 bonus-template_lh-28"
        :rules="[v => !!v || 'Expire is required']"
        v-model="bonus.expire_days"
        dense
      />
    </v-row>

    <v-row :class="{'justify-center': bonus.amount_by_day?.length}">
      <v-text-field
        required
        label="Max FS Win"
        type="number"
        v-model="bonus.max_freespin_win"
        hide-details
        class="col-4"
        dense
      />
      <v-spacer v-if="!bonus.amount_by_day?.length"></v-spacer>
      <v-text-field
        required
        label="Max Release"
        type="number"
        v-model="bonus.max_release"
        hide-details
        class="col-4"
        dense
      />
      <v-spacer v-if="!bonus.amount_by_day?.length"></v-spacer>
      <v-text-field
        v-if="!bonus.amount_by_day?.length"
        required
        label="Amount"
        type="number"
        :rules="[v => !!v && v !== '0' || 'Amount is required']"
        v-model="bonus.amount"
        hide-details
        class="col-4"
        dense
      >
        <template #append-outer>
          <v-btn
            icon
            title="Switch to a multiple-day schedule"
            style="margin-top: -5px"
            @click="onMultiDayToggle"
          >
            <v-icon>mdi-vector-square-plus</v-icon>
          </v-btn>
        </template>
      </v-text-field>
    </v-row>
    <v-row v-if="bonus.amount_by_day?.length" class="px-3">
      <fieldset
        class="pb-0 col-12 rounded-8"
      >
        <legend class="px-3" style="margin-bottom: -10px;">
          Freespin amount by day
          <v-btn
            icon
            color="primary"
            title="Add day"
            @click="bonus.amount_by_day.push(0)"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-btn
            icon
            color="error"
            title="Remove last day"
            :disabled="bonus.amount_by_day.length === 1"
            @click="bonus.amount_by_day.pop()"
          >
            <v-icon>mdi-minus</v-icon>
          </v-btn>
          <v-btn
            icon
            color="error"
            title="Return to single-use amount"
            @click="bonus.amount_by_day = []"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

        </legend>
        <v-row>
          <v-col
            v-for="(_, i) in bonus.amount_by_day"
            cols="2"
            class="pt-0"
            :key="i"
          >
            <v-text-field
              v-model.number="bonus.amount_by_day[i]"
              type="number"
              min="0"
              :label="`Day ${i + 1}`"
              hide-details
            />
          </v-col>
        </v-row>

      </fieldset>
      <v-col cols="2">
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-text-field
        required
        label="Bet Limits: Min"
        type="number"
        class="col-6"
        style="max-width: 150px"
        v-model="bonus.bet_limits_min"
        hide-details
      />

      <v-text-field
        required
        label="Bet Limits: Max"
        type="number"
        class="col-6"
        style="max-width: 150px"
        v-model="bonus.bet_limits_max"
        hide-details
      />
    </v-row>
    <v-divider class="mb-3 mt-2" />

    <v-label>Freespin win:</v-label>
    <v-row justify="center" class="px-0 mx-0 pt-2">
      <v-autocomplete
        label="Exclusive for Brand"
        clearable
        v-model="bonus.brand_exclusive"
        :loading="loadingGames"
        :items="providerBrandsAliases"
        dense
      />
      <v-spacer />
      <v-autocomplete
        label="Exclusive for System"
        clearable
        v-model="bonus.system_exclusive"
        :loading="loadingGames"
        :items="providerSystemsAliases"
        dense
      />
      <v-spacer />
      <v-autocomplete
        label="Exclusive for Game"
        item-text="name"
        item-value="game_id"
        clearable
        v-model="bonus.game_id_exclusive"
        :loading="loadingGames"
        :items="filteredGames"
        dense
      />
    </v-row>
    <v-divider class="mt-2" />

    <v-row class="px-0 mx-0 flex-wrap">
      <v-col
        cols="12"
        class="pb-0"
      >
        <v-label>Additional Requirements</v-label>
      </v-col>
      <v-col
        cols="6"
        v-for="(label, key) in additionalRequirementOptions"
        :key="key"
      >
        <v-checkbox
          v-model="bonus.additional_rules"
          class="mt-0"
          :label="label"
          :value="key"
          hide-details
          multiple
        />
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
  import { toString } from 'lodash'

  export default {

    props: [ 'bonus', 'providerSystemsAliases', 'providerBrandsAliases', 'games', 'brands', 'loadingGames' ],

    data: () => ({

      brandsFilter: '',
      brandsFilterInput: '',

      rollover_type: [
        { text: 'Bonus', value: 'bonus' },
        { text: 'Cash', value: 'cash' }
      ],

      statuses: [
        { text: 'New', value: 'new' },
        { text: 'Active', value: 'active' },
      ],
      additionalRequirementOptions: {
        'kyc.verified': 'KYC Verification',
        'kyc.primary_verification': 'KYC Automatic Verification',
        'account.data.verified.email': 'Email Verification',
        'account.data.verified.phone': 'Phone Number Verification',
      },
    }),

    methods: {
      toString,
      clearBrandFilter () {
        this.brandsFilterInput = ''
      },
      onMultiDayToggle() {
        if (!this.bonus.amount_by_day) {
          this.$set(this.bonus, 'amount_by_day', [])
        }
        this.bonus.amount_by_day.push(0)
      },
    },

    mounted () {
      if (this.$refs['bt-form-' + this.bonus.type]) this.$refs['bt-form-' + this.bonus.type].validate()
    },

    computed: {
      filteredGames: function () {
        return this.games.filter(g => {
          return this.brandsFilter.length < 1 || (this.brandsFilter.includes(g.brand.alias))
        })
      },
    }

  }
</script>
